// A one-time message for the login screen (msg 1a1a9f1d57db2a7e). Used when a
// session ends for a reason the person should read, e.g. a Friend whose 2-day
// portal window closed (BFF 401 code "friend_portal_window_closed"), instead
// of a bare "Session Expired".
//
// Stored in sessionStorage AND announced with a window event, because the
// login screen may already be mounted when the logout finishes.
export const FRIEND_WINDOW_CLOSED_CODE = "friend_portal_window_closed";
const KEY = "kindred_login_notice";
export const LOGIN_NOTICE_EVENT = "kindred-login-notice";

export const setLoginNotice = (message) => {
  if (!message) return;
  try { sessionStorage.setItem(KEY, message); } catch { /* storage off */ }
  try { window.dispatchEvent(new CustomEvent(LOGIN_NOTICE_EVENT, { detail: message })); } catch { /* no window */ }
};

export const takeLoginNotice = () => {
  try {
    const m = sessionStorage.getItem(KEY);
    if (m) sessionStorage.removeItem(KEY);
    return m || "";
  } catch {
    return "";
  }
};

// The notice a session-check failure should leave, or "" for a plain expiry.
export const noticeForSessionError = (err) =>
  err?.code === FRIEND_WINDOW_CLOSED_CODE ? err.message || "" : "";
